<template>
    <v-container fluid class="pa-0">
        <!-- @contextmenu.prevent="handleContextMenu" -->
        <!-- <v-btn icon @click="getBranchName()" v-if="loggedInUser.id == 1">
            <v-icon>mdi-plus</v-icon>
        </v-btn> -->
        <div v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" class="center">
            <img width="60%" height="60%" src="img/Latest Cadirai Logo 090223.png" class="hidden-sm-and-down"/>
        </div>

        <div v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" style="display: inline-block; vertical-align: top !important;">
            <calendar v-if="showCalendar" style="display: inline-block;"></calendar>
            <received-table style="display: inline-block;"></received-table>
        </div>

        <v-navigation-drawer v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" width="400px" absolute :right="$vuetify.breakpoint.mdAndUp" v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp">
            <v-row v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" dense>
                <v-col v-if="isUnderMaintenance == 1" cols="12" class="pb-0">
                    <!-- SYSTEM MAINTENANCE HOME PAGE -->
                    <v-card style="margin: 5px; overflow-y:aut;" height="220">
                        <v-toolbar dark flat height="48" style="background-color:#34495e;position: sticky; top: 0; z-index: 1;">
                            <v-divider horizontal />
                            <h4 class="ml-2 mr-2 blink_text"> <v-icon color="#FFA500">mdi-alert-outline</v-icon> 重要なお知らせ</h4>
                            <v-divider horizontal /> 
                        </v-toolbar>
                        <v-card-text>
                            <h4 style="color: blue;">システムメンテナンスのため、下記時間帯のシステムの利用ができません。</h4>
                            <br/>
                            <h4 style="color: red;">使用不可の時間帯</h4>
                            <h4 style="color: red;">{{japanDate}} {{japanTime}}（日本時間）</h4>
                            <h4 style="color: red;">※{{philippineTime}}（フィリピン時間）</h4>
                        </v-card-text>                             
                    </v-card>
                </v-col>
                <v-col v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" cols="12" class="pb-0">
                    <!-- SYSTEM LOGS HOME PAGE -->
                    <v-card style="margin: 5px;overflow-y:auto;" height="380">
                        <v-toolbar dark flat height="48"  style="background-color:#34495e;position: sticky; top: 0; z-index: 1;">
                            <v-divider horizontal />
                            <h4 class="ml-2 mr-2">システムアップデート履歴</h4>
                            <v-divider horizontal /> 
                        </v-toolbar>
                        <v-card-text class="pa-0 pt-1" style="overflow-y:auto;" :height="heightVersion">
                            <v-row v-for="(item,i) in homeLogs" :key="i" no-gutters >
                                <v-col>
                                    <v-card class="ml-2 mr-2 mb-2 pa-1" style="border: 1px solid #0d3f57;overflow-y: auto !important;">
                                        <span class="sem-bold-pop caption font-weight-bold" style="font-size: 12px; color:#434b56;">
                                            <v-chip small outlined color="#0d3f57" @click="openChipLogs()">
                                                <v-icon v-if="item.version == $store.state.verHeader" class="blink-icon" left>mdi-alpha-v-circle</v-icon>
                                                <v-icon v-else left>mdi-alpha-v-circle</v-icon>
                                                Version {{ item.version }}
                                            </v-chip>
                                            <span v-if="item.version == $store.state.verHeader" style="font-size:11px;"><v-icon small>mdi-arrow-left-bold</v-icon>Click here to view new update data</span>
                                        </span>
                                        <!-- <v-card-text class="pa-1 pl-2" dense hide-details v-for="(SUBITEM,ii) in item.imageattachment" :key="ii">
                                            <span style="font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif"> 
                                                {{ SUBITEM.file_name }}
                                            </span>
                                        </v-card-text> -->
                                        <v-card-text class="pa-1 pt-2" dense hide-details v-for="(SUBITEM,ii) in item.imageattachment" :key="ii">
                                            <ul style="list-style-type: square; line-height: 1.3;">
                                                <li style="font-size: 12px;">{{ SUBITEM.file_name }}</li>
                                            </ul>
                                        </v-card-text>
                                        <v-divider class="mt-2"></v-divider>
                                        <div class="caption text-right mt-1" style="font-size: 13px;">
                                            時点のCADリクエストデータ&nbsp;<b>{{ item.created_at.slice(0,10) }}</b>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" cols="12" class="pt-0">
                    <!-- FEEDBACK HOME PAGE -->
                    <v-card style="margin: 5px;overflow-y:auto;" :height="heightLogs">
                        <v-toolbar dark fixed dense flat height="48" style="background-color:#34495e;position: sticky; top: 0; z-index: 1;">
                            <v-divider horizontal />
                            <h4 class="ml-2 mr-2">フィードバック履歴</h4>
                            <v-divider horizontal />
                        </v-toolbar>
                        <v-card-text class="pa-0 pt-1" style="overflow-y:auto;">
                            <v-row v-show="feedbackData.length > 0" v-for="(item,i) in feedbackData" :key="i" no-gutters>
                                <v-col>
                                    <v-card class="ml-2 mr-2 mb-2 pa-1" style="border: 1px solid #0d3f57;overflow-y:auto;">
                                        <span class="overline font-weight-bold">Feedback No: {{ item.feedback_number }}</span>
                                        <img style="position:absolute;top:10px;" src="img/bell.gif" height="17px"><br>
                                        <span class="overline">FeedBack By: <b>{{ item.name }}</b> ({{item.created_at.slice(0,10)}})</span>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row v-show="feedbackData.length == 0" no-gutters align="center" justify="center">
                                <!-- <v-col> -->
                                    <v-card flat style="overflow:hidden;">
                                        <v-card-title class="mx-6" elevation="4" style="text-align: center;font-size:30px;font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;margin-top:15%;">NO FEEDBACK<br/> FOR TODAY</v-card-title>
                                    </v-card>
                                <!-- </v-col> -->
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-navigation-drawer>
        <div v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1" class="nav-btn">
            <v-btn fab class="hidden-md-and-up" @click.stop="drawer = !drawer">
                <v-icon>mdi-menu</v-icon>
            </v-btn>
        </div>

        <!-- NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28) -->
        <!-- SYSTEM UNDERMAINTENANCE MESSAGE -->
        <div v-if="isUnderMaintenance == 2" class="centered-div">
            <v-card height="300px" width="800px" elevation="0">
                <v-card-text class="d-flex justify-center align-center" style="height: 100%;">
                    <div class="text-center">
                        <h1 style="color: #A6AEBF">システムメンテナンス中</h1>
                        <br />
                        <h1 style="color: #A6AEBF" class="ma-3">下記時間帯はシステムの使用ができません。</h1>
                        <h1 style="color: #A6AEBF" class="ma-3">{{japanDate}} {{japanTime}}（日本時間）</h1>
                        <h1 style="color: #A6AEBF" class="ma-3">※{{philippineTime}}（フィリピン時間）</h1>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        
    </v-container>
</template>

<script>
import ReceivedTable from './ReceivedTable.vue'
import Calendar from './Calendar.vue'
import { mapState,mapActions } from 'vuex';

export default {
    components: {
        Calendar, ReceivedTable
    },
    data() {
        return {
            isMaintenance: null,
            isUnderMaintenance: null,
            japanDate: '',
            japanTime: '',
            philippineTime: '',
            systemMaintenanceDialog: false,
            heightVersion : window.innerHeight - 670,
            heightLogs : window.innerHeight - 495,
            homeLogs : [],
            feedbackData : [],
            getLatest : [],
            CRSUsers: [],
            env: {
                response: process.env.MIX_ENV == "local" ? "response-local" : "response",
                request: process.env.MIX_ENV == "local" ? "request-local" : "request",
            },
            showCalendar : true,
            drawer : null
        }
    },
    sockets: {
        // NOTE : SOCKET 
        updateReceived: async function(socket) {
            if(socket && socket.dispatchType == this.env.response && socket.functionType == 'response-branch' && socket.uniqId == this.loggedInUser.uniqId){
                if(socket.data.branches){
                    axios({
                        method: 'post',
                        url: 'api/save_branch_name',
                        data: socket.data.branches
                    }).then(({data}) => {
                        console.log(data)
                    })
                }
            }

            if(socket && socket.dispatchType == this.env.response && socket.functionType == 'test_socket_response' && socket.uniqId == this.loggedInUser.uniqId){ // example of socket
                console.log(socket, 'response') 
            }
        }
    },

    computed: {
        ...mapState([
            'loggedInUser'
        ])
    },
    methods: {
        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        async getSytemMaintenanceDatetime(){
            await axios({
                method: 'get',
                url: 'api/system_maintenance_datetime'
            }).then(({data}) => {
                this.isUnderMaintenance = data[0].is_undermaintenance;
                this.japanDate = data[0].japan_date;
                this.japanTime = data[0].japan_time;
                this.philippineTime = data[0].ph_time;
            })
        },

        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        async updateDateTime(){
            await axios({
                method: 'post',
                url: 'api/update_system_maintenance',
                data: {
                    japan_date: this.japanDate,
                    japan_time: this.japanTime,
                    ph_time: this.philippineTime,
                    is_undermaintenance: this.isMaintenance
                }
            }).then(({data}) => {
                this.getSytemMaintenanceDatetime();
                this.systemMaintenanceDialog = false;
            })
        },

        async getBranchName(){
            await axios({
                method: 'GET',
                url: 'api/getCadReq'
            }).then(async ({data}) => {
                console.log(data)
            })

            return;
            try {
                await this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    uniqId: this.loggedInUser.uniqId
                },
                functionType: 'getUsersBranchName'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },
        // test
        getSystemVersions(){
            axios({
                method : "GET",
                url : "api/getSystemVersion"
            }).then(({data}) => {
                this.homeLogs = data;
            })
        },

        openChipLogs(){
            window.open('logs');
        },

        getFeedBack(){
                axios({
                    method: "POST",
                    url: "api/feedbackData",
                }).then(({data}) => {
                    this.feedbackData = data;
                    // console.log(this.feedbackData,'this.feedbackData')
                })
            },
        // async testSocket(){
        //     try {
        //         await this.$socket.emit('newUpdate', {
        //             dispatchType: this.env.request, // request or response
        //             data: {                         // yung mga ipapadala mo sa socket
        //                 name: "Test test 123",
        //                 uniqId: this.loggedInUser.uniqId    // uniq id ni user para malaman kung sino nagrequest
        //             },
        //             functionType: 'test_socket' // for specific function call
        //         });
        //     } catch (error) {
        //         console.log(error, 'socket error');
        //     }
        // },

        // handleContextMenu(event) {
        //     // Prevent the default context menu behavior
        //     event.preventDefault();
        // },
        // handleKeyDown(event) {
        //     // Disable F12 and Ctrl+Shift+I (Windows/Linux) or Cmd+Option+I (Mac)
        //     if ((event.key === 'F12') || ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I')) {
        //         event.preventDefault();
        //     }
        //     // Disable right-click
        //     if (event.button === 2) {
        //         event.preventDefault();
        //     }
        // }
    },

    mounted() {
        this.getSystemVersions();
        this.getFeedBack();

        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        this.getSytemMaintenanceDatetime();


        // this.testSocket();

        // window.addEventListener('keydown', this.handleKeyDown);
        
    },
    beforeDestroy() {
        // Remove the keydown event listener when the component is destroyed
        // window.removeEventListener('keydown', this.handleKeyDown);
    },
}
</script>

<style>
.center{
    position:absolute;
    overflow:hidden;
    top: 15%;
    width: 100%;
    text-align:center;
    padding-right: 256px;
}

.blink-icon {
    animation: blink-animation 1.5s ease-in-out infinite alternate;
}

.blink_text {
    color: #FFA500;
    animation: blink-animation 1.5s ease-in-out infinite alternate;
}

@keyframes blink-animation {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

/* .container {
  display: flex;
  align-items: flex-start;
  margin: 0px;
  padding: 0px;
} */

.inline {
    display: inline-block;
    padding: 0px;
}

.nav-btn {
    position: absolute;
    /* height: 3rem; */
    /* z-index: 1; */
    right: 10px;
    top: 20px;
    bottom: 0; 
    .v-btn {
        margin: auto;
    }
}


.text{
    transform: scale(90%);
    margin: 5px;
}
.centered-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
